/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { getCandidateExportLogsFilterStatusSchema } from './GetCandidateExportLogsFilterStatusSchema'

export const getCandidateExportLogsFilterSchema = z.object({
	organisation_id: z.string().uuid(),
	campaign: z.string().uuid().nullable().optional(),
	form_submission: z.string().uuid().nullable().optional(),
	status: getCandidateExportLogsFilterStatusSchema.nullable().optional(),
})

export type GetCandidateExportLogsFilterSchema = z.infer<typeof getCandidateExportLogsFilterSchema>
